module.exports = __webpack_public_path__ + "img/footer-img-3.d2ac7604.png";